import React, { useContext, useRef, useState, useEffect } from "react";
import MyContext from "../../../context/MyContext";
import VideoPlayer from "../VideoPlayer";
import Draggable from "react-draggable";
import ProjectContext from "../../../context/ProjectContext";

const TrackerVideo = ({
  value,
  StackStore,
  TickerPosition,
  resizeRef2,
  zInd,
  index,
  resizeRef,
  TickerStart,
  MultiDrag,
  setMultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const {
    CanvasDisplay,
    setLayersData,
    LayersData,
    EditorZoom,
    onePxEquivalent,
    VideoPlayerRef,
    Dragging,
    setDragging,
    seteditableObject,
    IsPressedShiftKey,
  } = useContext(MyContext);
  const { slides, setslides } = useContext(ProjectContext);

  const dragref = useRef(null);

  const Unlock = async (obj) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
      }
    }
    setLayersData(array);
  };

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const VideoClick = (event, key) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        array[i].toolbar = true;
        array[i].Editable = true;
        array[i].showDiv = true;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
        array[i].showDiv = false;
      }
    }
    setLayersData(array);
  };

  const VideoRef = useRef(null);

  const Dragger = (e, data) => {
    if (data.node.nextSibling) {
      IsSetStateUpdate = true;
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";
      //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    }

    let change = false;

    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].waitSS = false;

        if (newArray[i].showDiv) {
          newArray[i].showDiv = false;
          change = true;
        }

        if (newArray[i].Editable) {
          newArray[i].Editable = false;
          change = true;
        }

        if (newArray[i].toolbar) {
          newArray[i].toolbar = false;
          change = true;
        }
      }
    }

    if (change) {
      setLayersData(newArray);
    }
  };

  var IsSetStateUpdate = false;

  const DragEnd = async (e, data) => {
    //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].Editable = true;
        newArray[i].toolbar = true;
        newArray[i].showDiv = true;
        newArray[i].waitSS = true;
        IsSetStateUpdate = false;
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
      } else {
        newArray[i].Editable = false;
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;

        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }

    // const _slides = Array.from(slides);
    // const active_slides = _slides.find(x => x.IsActive === true);
    // active_slides.LayerData = newArray;

    // setTimeout(() => {

    //     if(!IsSetStateUpdate)
    //     {
    //         setslides(_slides)
    //     }

    // }, 7000);

    // if (!Call_ScreenShot) {
    //   setCall_ScreenShot(true);
    // }
    setLayersData(newArray);
  };

  const activeEdit = (params) => {
    if (!IsPressedShiftKey) {
      const newArray = Array.from(LayersData);
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].Editable = true;
          newArray[i].toolbar = true;
          newArray[i].showDiv = true;
        } else {
          newArray[i].Editable = false;
          newArray[i].toolbar = false;
          newArray[i].showDiv = false;
        }
      }
      setLayersData(newArray);
      //ShowPanelLeft
      seteditableObject({ showPanel: true, editableItem: value });
    }
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      const arr = Array.from(MultiDrag);
      //setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key == value.key) {
          if (value.InMultiDrag === false) {
            arr.push(array[i]);
            array[i].InMultiDrag = true;
          } else {
            const index = arr.indexOf(value);

            if (index > -1) {
              // only splice array when item is found
              arr.splice(index, 1); // 2nd parameter means remove one item only
            }
            value.InMultiDrag = false;
            var element = document.getElementsByClassName(
              "Inner-" + value.AnimationId
            );
            if (element.length > 0) {
              element.classList.remove("disableEvents");
            }
          }
        }
      }
      if (arr.length === 1) {
        setMultiDrag([]);
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === arr[0].key) {
            array[i].showDiv = true;
            array[i].Editable = true;
          }
        }
      } else {
        setMultiDrag(arr);
      }

      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };

  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);
  const generateClassWithShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag disableEvents checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder disableEvents checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  const generateClassWithoutShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  return (
    <>
      {/* {!value.Editable && CanvasDisplay && (
                <MyResize Editable={value.Editable} resizeRef={VideoRef} type={value.type} values={value} />
            )} */}

      {!value.Editable && CanvasDisplay && !value.lock && (
        <Draggable
          defaultClassName={
            IsPressedShiftKey
              ? generateClassWithoutShift()
              : generateClassWithShift()
          }
          onMouseDown={(e) => {
            if (e.shiftKey) {
              Activated();
              return false;
            }
          }}
          onStart={(e) => {
            if (e.shiftKey) {
              return false;
            } else {
              setMultiDrag([]);
              setDragging(true);
              seteditableObject({ showPanel: true, editableItem: value });
            }
          }}
          onDrag={(event, data) => Dragger(event, data)}
          onStop={(event, data) => {
            DragEnd(event, data);
            setDragging(false);
          }}
          cancel={".resizable-handler , .square , .rotate"}
          position={{
            x: (value.x * EditorZoom) / 100,
            y: (value.y * EditorZoom) / 100,
          }}
        >
          <div
            id={`Inner-${value.AnimationId}`}
            ref={dragref}
            onClick={activeEdit}
            style={{
              // display: (!CanvasDisplay ? 'none' :
              //     TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ?
              //         'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
              width: (value.width * EditorZoom) / 100,
              height: (value.height * EditorZoom) / 100,
            }}
            //onClick={(event) => Click(event, value.key)}
          ></div>
        </Draggable>
      )}

      <div
        id={`Outer-${value.AnimationId}`}
        key={index}
        ref={!value.Editable ? VideoRef : resizeRef}
        className={
          "EditStart changer " +
          (value.Editable ? " RectBorder " : "") +
          (!CanvasDisplay ? value.InClass + value.OutClass : "")
        }
        style={{
          display: !CanvasDisplay
            ? value.player
              ? "inline-block"
              : "none"
            : value.startPositionOnTimeline <= TickerPosition &&
              value.startPositionOnTimeline + value.widthOnTimeline >=
                TickerPosition
            ? "inline-block"
            : "none",
          width: (value.width * EditorZoom) / 100,
          height: (value.height * EditorZoom) / 100,
          VendorAnimationDuration: ".5s",
          //zIndex: (value.Editable ? LayersData.length + 10 : zInd),
          zIndex: zInd,
          transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
          left: Math.round((value.x * EditorZoom) / 100),
          top: Math.round((value.y * EditorZoom) / 100),
        }}
        onClick={(event) => VideoClick(event, value.key)}
      >
        {/* {value.Editable === true && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={VideoRef} type={value.type} values={value} />
                )} */}
        {/* {!value.Editable && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={VideoRef} type={value.type} values={value} />
                )} */}
        <span style={{ display: value.lock ? "none" : "block" }}>
          <VideoPlayer
            value={value}
            onePx={onePxEquivalent}
            VideoPlayerRef={VideoPlayerRef}
          />
        </span>
      </div>

      {value.showDiv === true && (
        <div
          id={`showDiv-${value.AnimationId}`}
          ref={resizeRef2}
          style={{
            VendorAnimationDuration: ".5s",
            cursor: value.lock == true ? "default" : "grab",
            transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
            display: !CanvasDisplay
              ? value.player && !value.startAtoZ
                ? "inline-block"
                : "none"
              : value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
              ? "inline-block"
              : "none",
            height: (value.height * EditorZoom) / 100,
            width: (value.width * EditorZoom) / 100,
            zIndex: !value.lock ? 1000 : 1100 + 50,
            border:
              value.lock == true
                ? "1px dashed black"
                : value.Editable
                ? "2px solid #e87ed4"
                : "",
            left: Math.round((value.x * EditorZoom) / 100),
            top: Math.round((value.y * EditorZoom) / 100),
            position: "absolute",
          }}
        ></div>
      )}

      {/* {value.lock === true && value.opc === 1 && (
            <div className='RectBorder' key={index}
                style={{
                    position: "absolute", width: (value.width * EditorZoom) / 100, height: (value.height * EditorZoom) / 100, zIndex: zInd,
                    transform: `rotate(${value.rotateAngle}deg)`, left: Math.round((value.x * EditorZoom) / 100),
                    top: Math.round((value.y * EditorZoom) / 100), zIndex: 1500
                }}>
                <img key={index} draggable={false} className="selectedVideo" style={{ transform: value.flip }} tabIndex="0" src={value.ImageSrc}></img>
                <div data_set="lock_object" className="LockTop">
                    <div key={index} className="LockInnerBorder">
                        <span key={index} className="material-icons material-icons-outlined Lockback" tabIndex="0" onMouseOver={LockShow}>lock</span>
                        <span key={index} className="material-icons material-icons-outlined unlock " tabIndex="0" onMouseOut={locked} onClick={() => Unlock(value.key)}>lock_open</span>
                    </div>
                </div>
            </div>
        )} */}
    </>
  );
};
export default TrackerVideo;
